import React, { useLayoutEffect, useRef } from 'react'
import { gsap } from 'gsap'

import { Navigation, Social } from 'components/shared'

export default function Menu({ open, pageIsDonate }) {
  const target = useRef()
  const tl = useRef()
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline()
        .to(target.current, {
          height: '100%',
          visibility: 'visible',
        })
        .to('.fade-up', {
          opacity: 1,
          y: '0',
          stagger: {
            each: 0.2,
          },
        })
    }, target)
  }, [])
  useLayoutEffect(() => {
    //* Need to find a better way to handle tl speed and direction
    if (!open) {
      tl.current.timeScale(2)
      tl.current.reverse()
    } else {
      tl.current.timeScale(1)
      tl.current.play()
    }
  }, [open])

  useLayoutEffect(() => {
    if (open) {
      document.documentElement.classList.add('nav-active')
    } else {
      document.documentElement.classList.remove('nav-active')
    }
  })
  return (
    <div
      ref={target}
      className="absolute z-40 top-0 left-0 right-0 w-full h-0 invisible pt-[40px] bg-black md:hidden"
    >
      <div className="text-center container w-full h-full flex flex-col items-center justify-center">
        <Navigation inMenu pageIsDonate={pageIsDonate} />
        <Social inMenu />
      </div>
    </div>
  )
}
